import api from './api';

export interface ArtisanApiKey {
  id: string;
  name: string;
  prefix: string;
  status: 'active' | 'revoked';
  last_used_at?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateArtisanApiKeyResponse {
  api_key: ArtisanApiKey;
  key: string;
}

export const artisanIntegrationService = {
  getKeys: async () => {
    const response = await api.get<ArtisanApiKey[]>('/artisan/keys');
    return response.data;
  },

  createKey: async (name: string) => {
    const response = await api.post<CreateArtisanApiKeyResponse>('/artisan/keys', { name });
    return response.data;
  },

  revokeKey: async (id: string) => {
    await api.delete(`/artisan/keys/${id}`);
  },
};
